const RadioInputGroup = (props) => {
  const input = props.options
    .map(option => <label className='radio-inline'>
      <input type={'radio'}
        className={`qa-${option}`}
        onChange={() => props.onChange(option)}
        checked={option === props.value} />
      {option}
    </label>)
    .reduce((prev, curr) => prev.concat([' ', curr]), [])

  return <div className={`form-group qa-${props.title.split(' ').join('')}`}>
    <label>{props.title}</label>
    {
      props.meta ? props.meta : null
    }
    <div className={'radio-group'}>
      {input}
    </div>
  </div>
}

export default RadioInputGroup
